class ODPSLexer {

    static termChars = new Set([
        ' ', '\t', '.', '+', '-', '*', '/', '%', '<', '>', '=', '!', '\n', '\r', ';', '\'', '"', ',', '(', ')'
    ]);

    static operators = new Set([
        '+', '-', '*', '/', '%', '=', '!=', '<>', '<', '<=', '>', '>=', 'AND', 'OR', 'NOT', '~', '!'
    ]);

    constructor(text) {
        this.text = text;
        this.column = 1;
        this.line = 1;
        this.offset = 0;
    }

    next() {
        while (this.offset < this.text.length) {
            let ch = this.text[this.offset];
            //console.log(ch);
            switch (ch) {
                case '\'':
                case '"':
                    return this.matchStringLiteral(ch);

                case '`':
                    return this.matchId('`');

                case ',':
                case ';':
                case ':':
                case '(':
                case ')':
                case '{':
                case '}':
                case '[':
                case ']':
                    return this.token(ch, ch);

                case '\r':
                    ch = this.text[this.offset + 1];
                    if (ch === '\n') {
                        this.offset++;
                        this.column = 0;
                        this.line++;
                    }
                    break;

                case '\n':
                    this.column = 0;
                    this.line++;
                    break;

                case ' ':
                case '\t':
                    break;

                case '.':
                    ch = this.text[this.offset + 1];
                    if (ch === undefined) {
                        return this.eof();
                    }
                    if (ch.search(/[^0-9]/) === -1) {
                        return this.matchNumberLiteral();
                    } else {
                        return this.token('.', ch);
                    }

                case '-': {
                    let peek = this.text[this.offset + 1];
                    if (peek === undefined) {
                        return this.eof();
                    }
                    if (peek.search(/[^0-9]/) === -1) {
                        return this.matchNumberLiteral('-');
                    }
                    if (peek === '-') {
                        while (this.text[++this.offset] !== '\n') {
                            this.column++;
                            if (this.offset >= this.text.length) {
                                return this.eof();
                            }
                        }
                        this.column = 0;
                        this.line++;
                    } else {
                        return this.token('-', ch);
                    }
                } break;

                case '+':
                    ch = this.text[this.offset + 1];
                    if (ch === undefined) {
                        return this.eof();
                    }
                    if (ch.search(/[^0-9]/) === -1) {
                        return this.matchNumberLiteral('+');
                    }
                    return this.token('OP', ch);

                case '*':
                case '/':
                    return this.token('OP', ch);

                case '>':
                case '<': {
                    const token = { id: 'OP', value: ch, line: this.line, column: this.column };
                    ch = this.text[this.offset + 1];
                    if (ch === '=' || ch === '>') {
                        this.offset += 2;
                        this.column += 2;
                        token.value += ch;
                        return token;
                    }
                    return this.token('OP', token.value);
                }

                case '!':
                    const token = { id: 'OP', value: ch, line: this.line, column: this.column };
                    ch = this.text[this.offset + 1];
                    if (ch === '=') {
                        this.offset += 2;
                        this.column += 2;
                        token.value += ch;
                        return token;
                    }
                    return this.token('OP', token.value);

                case '=':
                    return this.token('OP', ch);

                default:
                    if (ch.search(/[^A-Za-z\s]/) === -1) {
                        return this.matchId();
                    }
                    if (ch.search(/[^0-9\s]/) === -1) {
                        return this.matchNumberLiteral();
                    }
                    return this.token('ERROR');
            }

            this.column++;
            this.offset++;
        }
        return this.eof();
    }

    eof() { return { id: 'EOF', line: this.line, column: this.column }; }

    token(id, value) {
        const token = { id, value, line: this.line, column: this.column };
        this.offset++;
        this.column++;
        return token;
    }

    matchStringLiteral(quote) {
        let token = { id: 'STRING_LITERAL', line: this.line, column: this.column };
        if (quote !== undefined) {
            this.offset++;
            this.column++;
        }

        let value = '';
        while (this.offset < this.text.length) {
            let ch = this.text[this.offset];
            if (ch === quote) {
                this.column++;
                this.offset++;
                break;
            } else if (ch === '\\') {
                this.column++;
                ch = this.text[++this.offset];
                switch (ch) {
                    case '\\': value += '\\'; break;
                    case 't': value += '\t'; break;
                    case 'n': value += '\n'; break;
                    case '\'': value += '\''; break;
                    case '"': value += '"'; break;
                    default:
                        throw this.error("bad string literal: " + ch);
                }
            } else {
                value += ch;
            }

            this.column++;
            this.offset++;
        }
        token.value = value;
        return token;
    }

    matchNumberLiteral(sign) {
        let value = '';
        if (sign === '-' || sign === '+') {
            this.offset++;
            //this.column++;
            value += sign;
        }
        let dot = 0;
        let token = { id: 'INT_LITERAL', line: this.line, column: this.column };
        while (this.offset < this.text.length) {
            let ch = this.text[this.offset];
            if (ch === '.') {
                if (dot > 0) {
                    throw this.error('bad token: duplicated dot in number.' + dot);
                }
                token.id = 'FLOAT_LITERAL';
                dot++;
                value += ch;
            } else if (ch.search(/[^0-9]/) === -1) {
                value += ch;
            } else if (ch.toUpperCase() === 'B') {
                value += ch;
                ch = this.text[++this.offset];
                if (ch.toUpperCase() === 'D') {
                    token.id = 'DECMAIL_LITERAL';
                    value += ch;

                    this.column++;
                    this.offset++;
                    break;
                } else {
                    throw this.error('bad token: BD postfix.');
                }
            } else if (ODPSLexer.termChars.has(ch)) {
                break;
            } else {
                throw this.error(`bad token: unexpected char \`${ch}' in number literal.`);
            }
            this.column++;
            this.offset++;
        }
        token.value = value;
        return token;
    }

    matchId(quote) {
        if (quote !== undefined) {
            this.offset++;
        }
        let s = '';
        let token = { line: this.line, column: this.column };
        while (this.offset < this.text.length) {
            let ch = this.text[this.offset];

            if (ch !== '' && ch.search(/[^_A-Za-z0-9]/) === -1) {
                s += ch;
            } else if (quote !== undefined && ch === quote) {
                this.column++;
                this.offset++;
                break;
            } else {
                break;
            }
            this.column++;
            this.offset++;
        }
        if (quote === '`') {
            token.id = 'ID';
            token.value = s;
        } else {
            token.id = ODPSParser.odpsKeywordsSet.has(s.toUpperCase()) ? s.toUpperCase() : 'ID';
            token.value = s;
        }
        return token;
    }

    error(message) {
        return new ODPSSyntaxException(this.line, this.column, undefined, message);
    }
}

class ODPSParser {
    static odpsKeywords = [
        'ADD',
        'AFTER',
        'ALL',
        'ALTER',
        'ANALYZE',
        'AND',
        'ARCHIVE',
        'ARRAY',
        'AS',
        'ASC',
        'BEFORE',
        'BETWEEN',
        'BIGINT',
        'BINARY',
        'BLOB',
        'BOOLEAN',
        'BOTH',
        'DECIMAL',
        'BUCKET',
        'BUCKETS',
        'BY',
        'CASCADE',
        'CASE',
        'CAST',
        'CFILE',
        'CHANGE',
        'CLUSTER',
        'CLUSTERED',
        'CLUSTERSTATUS',
        'COLLECTION',
        'COLUMN',
        'COLUMNS',
        'COMMENT',
        'COMPUTE',
        'CONCATENATE',
        'CONTINUE',
        'CREATE',
        'CROSS',
        'CURRENT',
        'CURSOR',
        'DATA',
        'DATABASE',
        'DATABASES',
        'DATE',
        'DATETIME',
        'DBPROPERTIES',
        'DEFERRED',
        'DELETE',
        'DELIMITED',
        'DESC',
        'DESCRIBE',
        'DIRECTORY',
        'DISABLE',
        'DISTINCT',
        'DISTRIBUTE',
        'DOUBLE',
        'DROP',
        'ELSE',
        'ENABLE',
        'END',
        'EXCEPT',
        'ESCAPED',
        'EXCLUSIVE',
        'EXISTS',
        'EXPLAIN',
        'EXPORT',
        'EXTENDED',
        'EXTERNAL',
        'FALSE',
        'FETCH',
        'FIELDS',
        'FILEFORMAT',
        'FIRST',
        'FLOAT',
        'FOLLOWING',
        'FORMAT',
        'FORMATTED',
        'FROM',
        'FULL',
        'FUNCTION',
        'FUNCTIONS',
        'GRANT',
        'GROUP',
        'HAVING',
        'HOLD_DDLTIME',
        'IDXPROPERTIES',
        'IF',
        'IMPORT',
        'IN',
        'INDEX',
        'INDEXES',
        'INPATH',
        'INPUTDRIVER',
        'INPUTFORMAT',
        'INSERT',
        'INT',
        'INTERSECT',
        'INTO',
        'IS',
        'ITEMS',
        'JOIN',
        'KEYS',
        'LATERAL',
        'LEFT',
        'LIFECYCLE',
        'LIKE',
        'LIMIT',
        'LINES',
        'LOAD',
        'LOCAL',
        'LOCATION',
        'LOCK',
        'LOCKS',
        'LONG',
        'MAP',
        'MAPJOIN',
        'MATERIALIZED',
        'MINUS',
        'MSCK',
        'NOT',
        'NO_DROP',
        'NULL',
        'OF',
        'OFFLINE',
        'OFFSET',
        'ON',
        'OPTION',
        'OR',
        'ORDER',
        'OUT',
        'OUTER',
        'OUTPUTDRIVER',
        'OUTPUTFORMAT',
        'OVER',
        'OVERWRITE',
        'PARTITION',
        'PARTITIONED',
        'PARTITIONPROPERTIES',
        'PARTITIONS',
        'PERCENT',
        'PLUS',
        'PRECEDING',
        'PRESERVE',
        'PROCEDURE',
        'PURGE',
        'RANGE',
        'RCFILE',
        'READ',
        'READONLY',
        'READS',
        'REBUILD',
        'RECORDREADER',
        'RECORDWRITER',
        'REDUCE',
        'REGEXP',
        'RENAME',
        'REPAIR',
        'REPLACE',
        'RESTRICT',
        'REVOKE',
        'RIGHT',
        'RLIKE',
        'ROW',
        'ROWS',
        'SCHEMA',
        'SCHEMAS',
        'SELECT',
        'SEMI',
        'SEQUENCEFILE',
        'SERDE',
        'SERDEPROPERTIES',
        'SET',
        'SHARED',
        'SHOW',
        'SHOW_DATABASE',
        'SMALLINT',
        'SORT',
        'SORTED',
        'SSL',
        'STATISTICS',
        'STATUS',
        'STORED',
        'STREAMTABLE',
        'STRING',
        'STRUCT',
        'TABLE',
        'TABLES',
        'TABLESAMPLE',
        'TBLPROPERTIES',
        'TEMPORARY',
        'TERMINATED',
        'TEXTFILE',
        'THEN',
        'TIMESTAMP',
        'TINYINT',
        'TO',
        'TOUCH',
        'TRANSFORM',
        'TRIGGER',
        'TRUE',
        'TYPE',
        'UNARCHIVE',
        'UNBOUNDED',
        'UNDO',
        'UNION',
        'UNIONTYPE',
        'UNIQUEJOIN',
        'UNLOCK',
        'UNSIGNED',
        'UPDATE',
        'USE',
        'USING',
        'UTC',
        'UTC_TMESTAMP',
        'VIEW',
        'WHEN',
        'WHERE',
        'WHILE',
        'DIV'
    ];

    static odpsKeywordsSet = new Set(this.odpsKeywords);

    static odpsTypeKeys = [
        'TINYINT',
        'SMALLINT',
        'INT',
        'BIGINT',
        'BINARY',
        'FLOAT',
        'DOUBLE',
        'DECIMAL',
        'VARCHAR',
        'CHAR',
        'STRING',
        'DATE',
        'DATETIME',
        'TIMESTAMP',
        'BOOLEAN'
    ];

    static odpsTypeKeysSet = new Set(this.odpsTypeKeys)

    static odpsFunctions = [
        'DATEADD',
        'DATE_ADD',
        'DATEDIFF',
        'DATEPART',
        'DATETRUNC',
        'FROM_UNIXTIME',
        'GETDATE',
        'ISDATE',
        'LASTDAY',
        'TO_DATE',
        'TO_CHAR',
        'UNIX_TIMESTAMP',
        'WEEKDAY',
        'WEEKOFYEAR',
        'ADD_MONTHS',
        'CURRENT_TIMESTAMP',
        'DAY',
        'DAYOFMONTH',
        'EXTRACT',
        'FROM_UTC_TIMESTAMP',
        'HOUR',
        'LAST_DAY',
        'MINUTE',
        'MONTH',
        'MONTHS_BETWEEN',
        'NEXT_DAY',
        'QUARTER',
        'SECOND',
        'YEAR',
        'ABS',
        'ACOS',
        'ASIN',
        'ATAN',
        'CEIL',
        'CONV',
        'COS',
        'COSH',
        'COT',
        'EXP',
        'FLOOR',
        'LN',
        'LOG',
        'POW',
        'RAND',
        'ROUND',
        'SIN',
        'SINH',
        'SQRT',
        'TAN',
        'TANH',
        'TRUNC',
        'BIN',
        'CBRT',
        'DEGREES',
        'E',
        'FACTORIAL',
        'FORMAT_NUMBER',
        'HEX',
        'LOG2',
        'LOG10',
        'PI',
        'RADIANS',
        'SIGN',
        'SHIFTLEFT',
        'SHIFTRIGHT',
        'SHIFTRIGHTUNSIGNED',
        'UNHEX',
        'WIDTH_BUCKET',
        'COUNT',
        'AVG',
        'MAX',
        'MIN',
        'MEDIAN',
        'STDDEV',
        'STDDEV_SAMP',
        'SUM',
        'DENSE_RANK',
        'RANK',
        'LAG',
        'LEAD',
        'PERCENT_RANK',
        'ROW_NUMBER',
        'CLUSTER_SAMPLE',
        'CUME_DIST',
        'NTILE',
        'AVG',
        'COUNT',
        'COUNT_IF',
        'MAX',
        'MIN',
        'MEDIAN',
        'STDDEV',
        'STDDEV_SAMP',
        'SUM',
        'WM_CONCAT',
        'ANY_VALUE',
        'APPROX_DISTINCT',
        'ARG_MAX',
        'ARG_MIN',
        'COLLECT_LIST',
        'COLLECT_SET',
        'COVAR_POP',
        'COVAR_SAMP',
        'NUMERIC_HISTOGRAM',
        'PERCENTILE',
        'PERCENTILE_APPROX',
        'VARIANCE',
        'VAR_POP',
        'VAR_SAMP',
        'ASCII',
        'BASE64',
        'CHAR_MATCHCOUNT',
        'CHR',
        'CONCAT',
        'FROM_JSON',
        'GET_JSON_OBJECT',
        'INSTR',
        'IS_ENCODING',
        'KEYVALUE',
        'LENGTH',
        'LENGTHB',
        'MD5',
        'PARSE_URL',
        'REGEXP_COUNT',
        'REGEXP_EXTRACT',
        'REGEXP_INSTR',
        'REGEXP_REPLACE',
        'REGEXP_SUBSTR',
        'SPLIT_PART',
        'SUBSTR',
        'SUBSTRING',
        'TO_CHAR',
        'TO_JSON',
        'TOLOWER',
        'TOUPPER',
        'TRIM',
        'LTRIM',
        'RTRIM',
        'REPEAT',
        'REVERSE',
        'UNBASE64',
        'CONCAT_WS',
        'JSON_TUPLE',
        'LPAD',
        'RPAD',
        'REPLACE',
        'SOUNDEX',
        'SUBSTRING_INDEX',
        'TRANSLATE',
        'URL_ENCODE',
        'URL_DECODE',
        'ARRAY',
        'ARRAY_CONTAINS',
        'ARRAY_INTERSECT',
        'CAST',
        'COALESCE',
        'DECODE',
        'EXPLODE',
        'GET_IDCARD_AGE',
        'GET_IDCARD_BIRTHDAY',
        'GET_IDCARD_SEX',
        'GET_USER_ID',
        'GREATEST',
        'IF',
        'INLINE',
        'LEAST',
        'MAP',
        'MAP_KEYS',
        'MAP_VALUES',
        'MAX_PT',
        'NAMED_STRUCT',
        'NVL',
        'ORDINAL',
        'PARTITION_EXISTS',
        'POSEXPLODE',
        'SAMPLE',
        'SIZE',
        'SORT_ARRAY',
        'SPLIT',
        'STACK',
        'STR_TO_MAP',
        'STRUCT',
        'TABLE_EXISTS',
        'TRANS_ARRAY',
        'TRANS_COLS',
        'UUID',
    ];

    static odpsStartupKeywords = new Set([
        'SELECT'
    ]);

    constructor(text, strict) {
        this.lexer = new ODPSLexer(text);
        this.lookAhead = this.lexer.next();
        this.strict = strict;
        this.errors = [];
    }

    parseBlock() {
        const stmts = [];
        while (this.peekId() !== 'EOF') {
            const stmt = this.parseStatement();

            if (stmt !== undefined) {
                stmts.push(stmt);
                if (!this.testId(';')) {
                    this.errors.push(this.error(this.lookAhead, `unexpected ;, expected ${this.lookAhead.id}`));
                }
            }
        }
        return stmts;
    }

    parseStatement() {
        switch (this.peekId()) {
            case 'SELECT':
                try {
                    let stmt = this.parseSelectStatement();
                    while (this.isSetOp(this.peekId())) {
                        const id = this.parseSetOp();
                        const rhs = this.parseSelectStatement();
                        stmt = { id, lhs: stmt, rhs };
                        //console.log(stmt);
                    }
                    return stmt;
                } catch (e) {
                    this.errors.push(e);
                    this.restart();
                }
                break;
            default:
                this.errors.push(this.error(this.lookAhead, `unexpected SELECT, expected ${this.lookAhead.id}('${this.lookAhead.value}')`));
                this.restart();
                if (this.peekId() === 'SELECT') {
                    return this.parseSelectStatement();
                }
                break;
        }
    }

    restart() {
        while (this.peekId() !== 'SELECT' &&
            this.peekId() !== ';' &&
            this.peekId() !== 'EOF') {
            this.moveNext();
        }
        this.testId(';');
    }

    parseSelectStatement() {
        const position = { start: this.makePosition(this.lookAhead) };
        this.match('SELECT');
        this.testId('DISTINCT');
        const projection = this.parseSelectionColumns({ line: position.start.line, column: position.start.column + 6 });
        const fromClause = this.peekId() === 'FROM' ? this.parseFromClause() : undefined;
        const whereClause = this.peekId() === 'WHERE' ? this.parseWhereClause() : undefined;
        const groupByClause = this.peekId() === 'GROUP' ? this.parseGroupByClause() : undefined;
        let havingClause;
        if (groupByClause !== undefined) {
            havingClause = this.peekId() === 'HAVING' ? this.parseHavingClause() : undefined;
        }
        const orderByClause = this.peekId() === 'ORDER' ? this.parseOrderByClause() : undefined;
        const limitClause = this.peekId() === 'LIMIT' ? this.parseLimitClause() : undefined;
        position.stop = this.makePosition(this.lookAhead);
        return { id: 'SELECT', projection, fromClause, whereClause, orderByClause, groupByClause, havingClause, limitClause, position };
    }

    parseSelectionColumns(position) {
        const columns = [this.parseSelectionColumn()];
        while (this.testId(',')) {
            columns.push(this.parseSelectionColumn());
        }
        return { position, columns };
    }

    parseSelectionColumn() {
        return this.testId('OP', '*') ? { col: '*' } : {
            col: this.parseExpression(),
            alias: this.parseAliasIfExists()
        }
    }

    parseFromClause() {
        this.match('FROM');
        let relation = this.parseFromRelation();

        for (; ;) {
            let hasJoinOp = true;
            switch (this.peekId()) {
                case 'JOIN':
                    this.moveNext();
                    break;
                case 'LEFT':
                    this.moveNext();
                    this.testId('OUTTER');
                    this.match('JOIN');
                    break;
                case ',':
                    this.moveNext();
                    break;
                case 'RIGHT':
                    this.moveNext();
                    this.testId('OUTTER');
                    this.match('JOIN');
                    break;
                case 'INNER':
                    this.moveNext();
                    this.match('JOIN');
                    break;
                default:
                    hasJoinOp = false;
                    break;
            }
            if (!hasJoinOp) {
                break;
            }
            const rhs = this.parseFromRelation();
            this.match('ON');
            const expr = this.parseExpression();
            relation = { join: 'JOIN', lhs: relation, rhs, on: expr };
        }
        return relation;
    }

    parseFromRelation() {
        let relation;
        if (this.testId('(')) {
            const subQuery = this.parseSelectStatement();
            this.match(')');
            const alias = this.parseAliasIfExists();
            relation = { subQuery, alias };
        } else {
            relation = this.parseTableRef();
        }
        return relation;
    }

    parseWhereClause() {
        this.match('WHERE');
        return this.parseExpression();
        // try {
        //     return this.parseExpression();
        // } catch (e) {
        //     console.log('invalid where clause: ' + e);
        // }
    }

    parseOrderByClause() {
        this.match('ORDER');
        this.match('BY');
        const orderBy = [{
            col: this.parseExpression(),
            order: this.parseAscOrDesc()
        }];
        while (this.testId(',')) {
            orderBy.push({
                col: this.parseExpression(),
                order: this.parseAscOrDesc()
            });
        }
        return orderBy;
    }

    parseGroupByClause() {
        this.match('GROUP');
        this.match('BY');
        return this.parseExpressionList();
    }

    parseHavingClause() {
        this.match('HAVING');
        return this.parseExpressionList();
    }

    parseLimitClause() {
        this.match('LIMIT');
        const limit = this.parseExpression();
        if (this.testId('OFFSET')) {
            const offset = this.parseExpression();
            return { limit, offset };
        }
        return { limit };
    }

    parseTableRef() {
        const schema = this.match('ID');
        let ref;
        if (this.testId('.')) {
            const name = this.match('ID');
            ref = { schema: schema.value, name: name.value };
        } else {
            ref = { schema: schema.value };
        }
        ref.alias = this.parseAliasIfExists()
        return ref;
    }

    parseAliasIfExists() {
        this.testId('AS');
        const token = this.lookAhead;
        switch (token.id) {
            case 'STRING_LITERAL':
            case 'ID':
                this.moveNext();
                return token.value;
            default:
                break;
        }
        return undefined;
    }

    parseExpressionList() {
        const expressions = [this.parseExpression()];
        while (this.testId(',')) {
            expressions.push(this.parseExpression());
        }
        return expressions;
    }

    parseExpression(notBoolExpr) {
        let op = this.peekId();
        let expr;
        if (op.id === 'OP' || op.id === 'NOT') {
            this.moveNext();
            expr = { op: op.id, operands: [this.parseExpression()] }
        } else {
            expr = this.parsePrimary();
        }
        op = this.lookAhead;
        if (notBoolExpr) {
            if (op.id === 'AND' || op.id === 'OR') {
                return expr;
            }
        }
        while (this.isOp(op.id)) {
            this.moveNext();

            switch (op.id) {
                case 'NOT':
                    if (this.peekId() === 'LIKE') {
                        this.moveNext();
                        expr = { op: 'NOT_LIKE', operands: [expr, this.parseExpression()] };
                    } else if (this.peekId() === 'IN') {
                        this.moveNext();
                        expr = this.parseInExpression('NOT_IN')
                    } else if (this.peekId() === 'BETWEEN') {
                        this.moveNext();
                        expr = this.parseBetweenExpression('NOT_BETWEEN');
                    } else {
                        throw this.error(this.lookAhead, `unexpected \`IN',\`LIKE',\`BETWEEN', expected: ${this.lookAhead.id}`);
                    }
                    break;

                case 'LIKE':
                    expr = { op: 'LIKE', operands: [expr, this.parseExpression()] };
                    break;

                case 'IS': {
                    const isNot = this.testId('NOT');
                    this.match('NULL');
                    expr = { op: isNot ? 'IS_NOT_NULL' : 'IS_NULL', operands: [expr] };
                } break;

                case 'IN':
                    expr = this.parseInExpression('IN');
                    break;

                case 'BETWEEN':
                    expr = this.parseBetweenExpression('BETWEEN');
                    break;

                default: {
                    const rhs = this.parseExpression();
                    expr = { op: op.value, operands: [expr, rhs] };
                    //console.log(expr);
                } break;
            }

            op = this.lookAhead;
        }
        return expr;
    }

    parseInExpression(op) {
        let expr;
        this.match('(');
        if (this.peekId() === 'SELECT') {
            expr = { op, operands: [expr, this.parseSelectStatement()] };
        } else {
            expr = { op, operands: [expr, this.parseExpressionList()] };
        }
        this.match(')');
        return expr;
    }

    parseBetweenExpression(op) {
        const begin = this.parseExpression(true);
        this.match('AND');
        const end = this.parseExpression(true);
        return { op, operands: [begin, end] };
    }

    parsePrimary() {
        const token = this.lookAhead;
        switch (token.id) {
            case 'ID': {
                this.moveNext();
                if (this.lookAhead.id === '(') {
                    return this.parseCalling(token.value);
                }
                if (this.testId('.')) {
                    if (this.isNoneStrictId()) {
                        const field = this.matchNoneStrictId();
                        return { dot: token.value, field: field.value };
                    } else if (this.testId('OP', '*')) {
                        return { dot: token.value, field: '*' };
                    } else if (!this.strict) {
                        return { dot: token.value, field: '' };
                    } else {
                        throw this.error(this.lookAhead, 'unexpected dot field');
                    }
                }

                return { id: token.value };
            }
            case 'OP':
                if (token.value === '*') {
                    this.moveNext();
                    return { type: 'ANY', literal: '*' };
                }
                break;
            case 'STRING_LITERAL':
                this.moveNext();
                return { type: 'STRING', literal: token.value };
            case 'INT_LITERAL':
                this.moveNext();
                return { type: 'INT', literal: token.value };
            case 'FLOAT_LITERAL':
                this.moveNext();
                return { type: 'FLOAT', literal: token.value };
            case 'DECIMAL_LITERAL':
                this.moveNext();
                return { type: 'DECIMAL', literal: token.value };
            case '(': {
                this.moveNext();
                const expr = this.parseExpression();
                this.match(')');
                return expr;
            }
            case 'CASE': {
                this.moveNext();
                let primaryExpr;
                if (this.lookAhead.id !== 'WHEN') {
                    primaryExpr = this.parseExpression();
                }

                const whenClause = [];
                while (this.testId('WHEN')) {
                    const condition = this.parseExpression();
                    this.match('THEN')
                    const then = this.parseExpression();
                    whenClause.push({ condition, then });
                }
                let elseExpr
                if (this.testId('ELSE')) {
                    elseExpr = this.parseExpression();
                }

                this.match('END');
                return { op: 'CASE_WHEN', primary: primaryExpr, 'else': elseExpr, operands: whenClause };
            }
            case 'CAST': {
                this.moveNext();
                this.match('(');
                const primaryExpr = this.parseExpression();
                this.match('AS');
                const type = this.parseTypeDesc();
                this.match(')');
                return { op: 'CAST', primary: primaryExpr, type };
            }
            default:
                throw this.error(this.lookAhead, `unexpected primary expression, expected ${token.id}`);
        }
    }

    parseCalling(callee) {
        this.match('(');
        const distinct = this.testId('DISTINCT');
        let args = [];
        if (!this.testId(')')) {
            args = this.parseExpressionList();
            this.match(')');
        }

        let window;
        if (this.testId('OVER')) {
            window = {
                partitionBy: [],
                orderBy: []
            };
            if (this.testId('(')) {
                this.match('PARTITION');
                this.match('BY');

                window.partitionBy.push(this.parseColumnName());
                while (this.testId(',')) {
                    window.partitionBy.push(this.parseColumnName());
                }

                if (this.testId('ORDER')) {
                    this.match('BY');
                    window.orderBy.push({
                        col: this.parseExpression(),
                        order: this.parseAscOrDesc()
                    });
                    while (this.testId(',')) {
                        window.orderBy.push({
                            col: this.parseExpression(),
                            order: this.parseAscOrDesc()
                        });
                    }
                }

                if (window.orderBy.length > 0) {
                    if (this.testId('ROWS')) {
                        window.windowingClause = {};
                        if (this.testId('BETWEEN')) {
                            window.windowingClause.x = {
                                rows: this.parseExpression(),
                                direction: this.parsePrecedingOrFollowing()
                            };
                            this.match('AND');
                            window.windowingClause.y = {
                                rows: this.parseExpression(),
                                direction: this.parsePrecedingOrFollowing()
                            };
                        } else {
                            window.windowingClause.x = {
                                rows: this.parseExpression(),
                                direction: this.parsePrecedingOrFollowing()
                            };
                        }
                    }
                }
                this.match(')');
            }
        }
        const expr = { call: callee, distinct, args, window };

        return expr;
    }

    parseColumnName() {
        const col = this.matchNoneStrictId();
        if (this.testId('.')) {
            if (this.isNoneStrictId()) {
                const field = this.matchNoneStrictId();
                return { dot: col.value, field: field.value };
            }
        }
        return col.value;
    }

    parsePrecedingOrFollowing() {
        switch (this.peekId()) {
            case 'FOLLOWING':
                this.moveNext();
                return false;
            default:
                this.match('PRECEDING');
                return true;
        }
    }

    parseAscOrDesc() {
        switch (this.peekId()) {
            case 'ASC':
                this.moveNext();
                return 'ASC';
            case 'DESC':
                this.moveNext();
                return 'DESC';
            default:
                return 'ASC';
        }
    }

    parseTypeDesc() {
        const token = this.lookAhead;
        switch (token.id) {
            case 'DECIMAL':
                //console.log(token);
                this.moveNext();
                this.match('(');
                const s1 = this.match('INT_LITERAL');
                this.match(',');
                const s2 = this.match('INT_LITERAL');
                this.match(')');
                return { type: token.id, size: [s1.value, s2.value] };
            case 'VARCHAR':
            case 'CHAR':
                this.moveNext();
                this.match('(');
                let size = this.match('INT_LITERAL');
                this.match(')');
                return { type: token.id, size: [size.value] };
            default:
                if (!ODPSParser.odpsTypeKeysSet.has(token.id)) {
                    throw this.error(token, 'bad type token');
                }
                this.moveNext();
                return { type: token.id };
        }
    }

    parseSetOp() {
        let token = this.lookAhead;
        let op;
        switch (token.id) {
            case 'INTERSECT':
            case 'UNION':
            case 'EXCEPT':
            case 'MINUS':
                op = token.id
                this.moveNext();
                break;
            default:
                this.error(token, 'bad set op');
                break;
        }
        token = this.lookAhead;
        switch (token.id) {
            case 'ALL':
                op += '_ALL';
                this.moveNext();
                break;
            case 'DISTINCT':
                op += '_DISTINCT';
                this.moveNext();
                break;
            default:
                break;
        }
        return op;
    }

    matchNoneStrictId() {
        if (this.isNoneStrictId()) {
            const token = this.lookAhead;
            this.moveNext();
            return token;
        }
        throw this.error(this.lookAhead, `unexpected ID, expected ${this.lookAhead.id}`);
    }

    isNoneStrictId() {
        return this.lookAhead.id === 'ID' || (ODPSParser.odpsKeywordsSet.has(this.lookAhead.id) && this.lookAhead.id !== 'FROM');
    }

    makePosition(token) {
        return { line: token.line, column: token.column };
    }

    testOp() {
        const op = this.peekId();
        if (this.isOp(op.id)) {
            this.moveNext();
        }
        return op;
    }

    isSetOp(id) {
        switch (id) {
            case 'INTERSECT':
            case 'UNION':
            case 'EXCEPT':
            case 'MINUS':
                return true;
            default:
                return false;
        }
    }

    isOp(id) {
        switch (id) {
            case 'IS':
            case 'IN':
            case 'LIKE':
            case 'BETWEEN':
            case 'AND':
            case 'OR':
            case 'NOT':
            case 'OP':
            case 'CASE':
                return true;
            default:
                return false;
        }
    }

    isBoolOp(id) {
        switch (id) {
            case 'AND':
            case 'OK':
            case 'NOT':
                return true;
            default:
                return false;
        }
    }

    testId(id) {
        if (this.peekId() === id) {
            this.moveNext();
            return true;
        }
        return false;
    }

    peekId() { return this.lookAhead.id; }

    match(id, value) {
        const token = this.lookAhead;
        if (id !== undefined && value !== undefined) {
            if (this.lookAhead.id !== id ||
                this.lookAhead.value !== value) {
                throw this.error(this.lookAhead, `unexpected {${id}, ${value}}, expected: ${this.lookAhead.id}`);
            }
            this.moveNext();
        } else {
            if (this.lookAhead.id !== id) {
                throw this.error(this.lookAhead, `unexpected ${id}, expected: ${this.lookAhead.id}`);
            }
            this.moveNext();
        }
        return token;
    }

    moveNext() {
        this.lookAhead = this.lexer.next();
    }

    error(token, message) {
        return new ODPSSyntaxException(token.line, token.column, token, message)
    }
}

class ODPSSyntaxException {
    constructor(line, column, token, message) {
        this.line = line;
        this.column = column;
        this.token = token;
        this.message = message;
    }
}

export { ODPSLexer, ODPSParser, ODPSSyntaxException };